import HtmlElement from '../../../../Js/Elements/HtmlElement';
import Countdown from './Countdown';
import Percentage from './Percentage';

/**
 * Countdown
 */
const Scarcity = (() => {
	/**
	 * Selector
	 *
	 * @var { Object }
	 */
	const Selector = {
		SCARCITY: '.scarcity',
		AVAILABILITY: '.scarcity-availability',
		COUNTDOWN: '.scarcity-countdown',
		WRAP: '.scarcity-wrap',
		PERCENTAGE: '.scarcity-percentage',
		AVAILABILITY_TEXT: '.scarcity-availability-text',
		FINISHED: '.scarcity-finished'
	};

	/**
	 * Scarcity
	 *
	 * @class
	 * @augments HtmlElement
	 */
	class Scarcity extends HtmlElement {
		// Public

		/**
		 * Handles ready event
		 *
		 * @return void
		 */
		onReady() {
			super.onReady();

			this._uid = this.$element.data('uid');
			this._content = this.$element.data('content');
			this._$wrap = this.$element.find(Selector.WRAP);

			this._fetch();
		}

		_fetch() {
			$.ajax({
				url: window.location.origin,
				type: 'GET',
				data: {
					type: 5250,
					s: this._uid,
					c: this._content
				},
				success: (data) => {
					const $html = $(data);
					const $finished = $html.find(Selector.FINISHED);

					if ($finished.length) {
						this._triggerFinished();
					} else {
						const $availabilityText = $html.find(Selector.AVAILABILITY_TEXT);
						const $percentage = $html.find(Selector.PERCENTAGE);
						const $countdown = $html.find(Selector.COUNTDOWN);

						if ($availabilityText.length) {
							this._initializeAvailability($availabilityText.contents(), $percentage);
						}

						if ($countdown.length) {
							this._initializeCountdown($countdown.data('end'));
						}
					}
				}
			});
		}

		_initializeAvailability($availabilityText, $percentage) {
			const $availability = this.$element.find(Selector.AVAILABILITY);
			const $value = this.$element.find(Selector.AVAILABILITY_TEXT);
			$value.html($availabilityText);
			$availability.addClass('initialized');

			if ($percentage.length) {
				this._initializePercentage($percentage.data('current'), $percentage.data('max'));
			}
		}

		_initializePercentage(current, max) {
			const $percentage = this.$element.find(Selector.PERCENTAGE);
			$percentage.data('current', current);
			$percentage.data('max', max);
			const percentage = new Percentage($percentage);
			percentage.onReady();
		}

		_initializeCountdown(endTimestamp) {
			const $countdown = this.$element.find(Selector.COUNTDOWN);
			$countdown.data('end', endTimestamp);
			const countdown = new Countdown($countdown);
			countdown.onReady();
		}

		_triggerFinished() {
			const $finished = this.$element.find(Selector.FINISHED);
			this._$wrap.fadeOut(300, () => {
				$finished.fadeIn(300);
			});
		}
	}

	return Scarcity._getElements(Selector.SCARCITY, Scarcity);
})();

export default Scarcity;
